<template>
	<section class="bg-inherit py-7 lg:py-14">
		<div class="container mx-auto max-w-screen-xl px-4">
			<h2
				class="text-main-400 xs:text-32 sm:text-36 md:text-38 mb-4 text-center text-3xl font-bold leading-tight lg:mb-6 lg:text-4xl"
			>
				{{ title }}
			</h2>

			<p
				v-if="!hidePhone"
				class="text-primary mx-auto mb-4 max-w-4xl text-center text-xl md:mb-6 lg:text-3xl"
			>
				Here are answers to the questions we hear most frequently/ Still wondering? Contact
				us directly at {{ config.getConfigContent('phone', '000-000-0000') }}
			</p>

			<div class="mx-auto w-full">
				<AppDetails
					v-for="(question, index) in questions"
					:key="index"
					:open="index === openIndex"
					class="mb-3"
					:heading="question.question"
					:text="question.answer"
					@click="e => onDetailClick(e, index)"
				/>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
	import AppDetails from './AppDetails.vue'
	import { Question, useConfigStore } from '../../../stores/config'
	import { computed, ref } from 'vue'

	const openIndex = ref(1)

	withDefaults(defineProps<{ title?: string; hidePhone?: boolean }>(), {
		title: 'Questions? We’ve Got Answers!',
	})
	const config = useConfigStore()
	const questions = computed(() => config.getConfigContent<Question[]>('questions', []))

	const onDetailClick = (event: Event | null, index: number) => {
		event?.preventDefault()
		if (index === openIndex.value) {
			openIndex.value = -1
			return
		}
		openIndex.value = index
	}
</script>
